import { motion } from "framer-motion";
import { CreditCard, Smartphone, Car } from "lucide-react";

const STEPS = [
  {
    n: 1, icon: Smartphone, t: "Pay ₹1,249 online",
    d: "Razorpay-secured checkout. UPI, cards, netbanking — all instant.",
  },
  {
    n: 2, icon: Car, t: "Add your car(s)",
    d: "Register up to 2 cars under one Care+ membership. 30-second setup.",
  },
  {
    n: 3, icon: CreditCard, t: "Redeem at AutoHQ",
    d: "Show your coupons on visit. We deduct from your wallet automatically.",
  },
];

export default function CPHowItWorks() {
  return (
    <section data-testid="cp-how" className="bg-white text-[#0A0A0A] px-5 lg:px-8 py-16 sm:py-20 border-y border-[#E4E4E7]">
      <div className="max-w-5xl mx-auto">
        <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">How it works</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight max-w-2xl">
          From card swipe to clean car in under 60 seconds.
        </h2>

        <div className="mt-10 grid sm:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-[#FAFAFA] border border-[#E4E4E7] rounded-sm p-6"
            >
              <div className="flex items-center justify-between mb-5">
                <s.icon className="w-6 h-6 text-[#0A0A0A]" />
                <span className="text-4xl font-extrabold text-[#D4AF37]/30 leading-none">0{s.n}</span>
              </div>
              <h3 className="font-bold text-base">{s.t}</h3>
              <p className="mt-2 text-sm text-[#52525B] leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
